import React, { useEffect, useState } from 'react';
import { AuthService } from '../services/api';
import LegalCheckboxes from './LegalCheckboxes';
import Message from './Message';

/**
 * Bloque l'accès tant que la version courante des documents juridiques n'a pas été acceptée.
 * N'affiche que les documents en attente, chacun avec sa propre case.
 */
const LegalGate = ({ children }) => {
    const [docs, setDocs] = useState(null);
    const [pending, setPending] = useState(null);
    const [checked, setChecked] = useState({});
    const [error, setError] = useState('');
    const [saving, setSaving] = useState(false);

    const load = async () => {
        const [legal, status] = await Promise.all([AuthService.getLegal(), AuthService.getLegalStatus()]);
        setDocs(legal);
        setPending(status.pending);
        setChecked({});
    };

    useEffect(() => {
        load().catch(() => setError('Impossible de vérifier les conditions d\'utilisation. Veuillez réessayer.'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (pending === null) return error ? <Message>{error}</Message> : null;
    if (pending.length === 0) return children;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        setError('');
        try {
            const payload = {};
            pending.forEach((type) => {
                payload[`accept_${type}`] = true;
                payload[`${type}_version`] = docs[type].version;
            });
            const status = await AuthService.acceptLegal(payload);
            setPending(status.pending);
        } catch (err) {
            if (err.response?.status === 409) {
                await load().catch(() => {});
                setError('Les documents ont été mis à jour, veuillez les relire et les accepter à nouveau.');
            } else {
                setError('Une erreur est survenue. Veuillez réessayer.');
            }
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="signup-container">
            <h2>Mise à jour de nos conditions</h2>
            <p>Pour continuer à utiliser le service, veuillez lire et accepter :</p>
            {error && <Message>{error}</Message>}
            <form onSubmit={handleSubmit}>
                <LegalCheckboxes
                    docs={docs}
                    types={pending}
                    checked={checked}
                    onChange={(type, value) => setChecked((prev) => ({ ...prev, [type]: value }))}
                />
                <button type="submit" disabled={saving || !pending.every((type) => checked[type])}>
                    {saving ? 'Enregistrement...' : 'Accepter et continuer'}
                </button>
            </form>
        </div>
    );
};

export default LegalGate;
